import { useFormContext } from 'react-hook-form';
import { SearchableSelect } from '../../../components/SearchableSelect';
import { useCatalogCategoryOptions } from './useCatalogCategoryOptions';

interface CatalogCategorySelectProps {
  name: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  excludedId?: number;
  error?: string;
}

export function CatalogCategorySelect({ name, label, value, onChange, excludedId, error }: CatalogCategorySelectProps) {
  const { formState } = useFormContext();
  const categories = useCatalogCategoryOptions(value, excludedId);
  return <>
    <SearchableSelect isDisabled={formState.isSubmitting} inputId={name} ariaLabel={label} ariaInvalid={Boolean(error)} ariaDescribedBy={error ? `${name}-error` : undefined} isClearable options={categories.options} value={value} onChange={onChange} onSearchChange={categories.setSearch} placeholder={excludedId === undefined && name === 'product_category_id' ? 'Без категории' : 'Верхний уровень'} noOptionsMessage={categories.isLoading ? 'Загружаем…' : 'Категории не найдены'} />
    {categories.error ? <span role="alert">Не удалось загрузить категории. Повторите поиск.</span> : null}
  </>;
}
